import analysisApi from 'api/analysis';
import AnalysisTabs from 'components/analysisTabs';
import branchApi from 'api/branch';
import customerApi from 'api/customer';
import dealerApi from 'api/dealer';
import downloadCSV from 'helpers/csvHelpers';
import EmailModal from 'components/layout/emailModal';
import events from 'lib/events';
import FooterButton from 'components/layout/footerButton';
import generateDetailedView, {formatCell, generateBlankCells, IDEAL_TESTS} from './reportDetailedView';
import Header from 'components/layout/header';
import HoverButton from 'components/layout/hoverButton';
import LayoutDatePicker from 'components/forms/layoutDatePicker';
import Loader from 'components/loader';
import moment from 'moment';
import PageFooter from 'components/layout/pageFooter';
import path from 'path';
import poolApi from 'api/pool';
import productApi from 'api/product';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {dateTimeFormats, emailSendingTypes, chemicalBaseTypeNames, countries} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {idealRangesFormatted, getContactName} from 'helpers/dataHelpers';
import IntlWrapper from 'components/layout/intlWrapper';
import CustomIntlWrapper from 'components/layout/customIntlWrapper';
import {languages} from 'helpers/languageHelper';
import {getAllNotes} from 'api/note';

let render = (container, params) => {
  console.info('[UI.page.customer] rendering page');
  events.publish('page-change', {page: 'customer'});

  let _id;
  let _contactid;

  if (params.id) {
    _id = parseInt(params.id.split('.')[0]);
    _contactid = parseInt(params.id.split('.').length > 1 ? params.id.split('.')[1] : null);
  }

  ReactDOM.render(
    <IntlWrapper>
      <WrapperWaterAnalysisReport
        customerID={_id}
        contactId={_contactid}
        poolID={params.system}
        analysisID={params.analysisID}
        showPrint={!!params.print}/>
    </IntlWrapper>,
    container
  );
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'customer/:id/:system/report-history/', handler: routeUtils.requireAuth(render)}]);

function getReportLink(systemID, analysis) {
  let hash = location.hash;

  //1440 minutes = 24 hours
  if (moment().diff(analysis.created, 'minutes') < 1440) {
    return path.join(hash, '..', 'analysis', 'report', analysis.id.toString());
  }
  return path.join(hash, '..', 'analysis', 'report', 'history', analysis.id.toString());
}

// Page object
class WaterAnalysisReport extends React.Component {
  static propTypes = {
    customerID: PropTypes.string,
    poolID: PropTypes.string,
    showPrint: PropTypes.bool,
    intl: intlShape.isRequired,
  };

  state = {
    analyses: [],
    customer: {
      customerContacts: [],
    },
    messages: {
      'en-US': {},
      'fr-CA': {},
    },
    dealer: {},
    loaded: false,
    pool: {},
    poolTypeText: '',
    products: [],
    start: moment().subtract(1, 'year'),
    end: moment(),
    firstTest: 0,
    lastTest: 4,
    posdata: true,
    user: session.getUser(),
  };

  componentDidMount() {
    this.fetchData();
  }

  componentWillReceiveProps(props) {
    this.props = props;
    this.fetchData();
  }

  componentDidUpdate() {
    if (!this.state.loaded) {
      this.fetchData();
    }
  }

  getPOSRow = () => {
    let output;
    let {formatMessage} = this.props.intl;

    if (this.checkPOSPermission()) {
      output =
        <tr className="collapse-row tablerow-separator"
            onClick={this.togglePOSData}>
          <td colSpan="5">
            <i className={'collapse-icon bl bl-' + (this.state.posdata ? 'minus' : 'plus add-circle')}/>
            {this.state.posdata ? formatMessage({id: 'test.history.hide.data'}) : formatMessage({id: 'test.history.show.data'})}
          </td>
        </tr>;
    }
    return output;
  };

  getPurchaseTable = (purchases, analyses, start, end) => { //Generates Purchase Data Table for display below analysis history
    let output = null;
    let {formatMessage} = this.props.intl;

    if (this.checkPOSPermission()) {
      const table = [
        [formatMessage({id: 'general.total.bioguard.purchases'})],
        [formatMessage({id: 'general.products.purchased'})],
      ];

      //Generate 2 dimensional array of data for custom layout
      if (purchases) {
        const currentAnalyses = analyses.slice(start, end);
        const currentPurchases = purchases.slice(start, end);

        for (let i = 0; i < currentPurchases.length; i++) {
          if (currentPurchases[i].id === currentAnalyses[i].id) { //Check that tables are synced
            table[0][1 + i] = currentPurchases[i].total ? '$' + currentPurchases[i].total :
            <FormattedMessage id='general.no.purchase'/>;

            for (let j = 0; j < currentPurchases[i].products.length; j++) {
              if (table[1 + j] === undefined) {
                table[1 + j] = [''];
              }
              table[1 + j][1 + i] = currentPurchases[i].products[j];
            }
          }
        }
      }

      //Return Table Object
      output =
        <tbody>
          {table.map(row =>
            <tr className={row[0] !== '' ? 'tablerow-separator' : ''}>
              {[0, 1, 2, 3, 4].map(index =>
                <td>{row[index] !== undefined ? row[index] : '-'}</td>
            )}
            </tr>
        )}
        </tbody>;
    }
    return output;
  };

  getPurchasesForAnalyses = (analyses) => {
    const ids = analyses.map(analysis => {
      return analysis.id;
    });

    analysisApi.getAnalysisPurchases(ids).then(purchaseData => {
      this.setState({purchaseData: purchaseData});
    });
  };

  getReport = () => {
    let report;
    let {formatMessage} = this.props.intl;
    let columns = this.state.analyses.slice(this.state.firstTest, this.state.lastTest);
    let tableRows = generateDetailedView(this.props.intl, this.state.dealer, this.state.branch, this.state.pool,
      this.state.products, columns, formatMessage, true, false, true);
    let posRow = this.getPOSRow();
    const categoriesWidth = 25;
    let columnWidth = 75 / IDEAL_TESTS;

    let purchaseTable = this.getPurchaseTable(this.state.purchaseData, this.state.analyses, this.state.firstTest, this.state.lastTest);

    let reportHeaders = this.state.analyses
      .slice(this.state.firstTest, this.state.lastTest)
      .map((analysis, i) => {
        const note = this.state.notes.find(x => x.analysisID === analysis.id);

        return <th key={'tabledateheader' + i}
                   style={{width: columnWidth + '%'}}>
          {analysis.created ?
            <span>
              {note ? <ToolTip invert iconOnly iconClass='bl bl-notes' topLeft title={<div>
                <p><strong>{note.name}</strong></p>
                <p>{note.body.length > 200 ? note.body.slice(0, 200) + '...' : note.body}</p>
                <p><a className='link' style={{textDecoration: 'underline'}} href={`/#customer/timeline/${this.props.customerID}`}>View More</a></p>
              </div>} /> : null}

              <a style={{color: 'white', textDecoration: 'none'}}
                 href={getReportLink(this.props.poolID, analysis)}>
                <span style={{textDecoration: 'underline'}}>{moment(analysis.created).format('ll')}</span>
                &nbsp;<i className='fa fa-caret-right'/>
              </a>
            </span> :
            formatMessage({id: 'test.history.no.analysis'})
          }
        </th>;
      });

    report = <table className='table-biolab analysis-report table-striped table-vertical-rules report-history-table'>
      <thead>
        <tr>
          <th style={{width: categoriesWidth + '%'}}>
            <ToolTip title={formatMessage({id: 'test.history.three.categories'})}
                   position={tooltipPositions.topLeft}
                   iconOnly
                   invert/>
            {formatMessage({id: 'general.categories'})} <span>({formatMessage({id: 'general.ideal'})})</span>
          </th>
          {reportHeaders}
          {generateBlankCells(reportHeaders.length, IDEAL_TESTS, 'th')}
        </tr>
      </thead>
      <tbody>
        {tableRows}
        {posRow}
      </tbody>

      {this.state.posdata && purchaseTable}

      <tbody>
        <tr className='tablerow-separator'>
          <td/>
          {columns.map(a => <td key={a.id}>
            <a className='btn btn-primary'
             href={getReportLink(this.props.poolID, a)}>{formatMessage({id: 'general.view.report'})}</a>
          </td>)}
          {generateBlankCells(columns.length)}
        </tr>
      </tbody>
    </table>;

    return !this.props.showPrint ? report : null;
  };

  getReportForEmail = (locale = 'en-US') => {
    const Inner = injectIntl(({intl}) => {
      const {formatMessage} = intl;

      let columns = this.state.analyses.slice(this.state.firstTest, this.state.lastTest);
      let tableRows = generateDetailedView(intl, this.state.dealer, this.state.branch,
        this.state.pool, this.state.products, columns, formatMessage, true, false,
        false, true);

      let reportHeaders = this.state.analyses
        .slice(this.state.firstTest, this.state.lastTest)
        .map((analysis, i) =>
          <th key={'tabledateheader' + i}>
            {analysis.created ?
              <span>{moment(analysis.created).locale(languages[locale].time).format('ll')}</span> :
              formatMessage({id: 'test.history.no.analysis'})
            }
          </th>
        );

      return <table className='table-biolab analysis-report table-striped table-vertical-rules'>
        <thead>
          <tr>
            <th>{formatMessage({id: 'general.categories'})} ({formatMessage({id: 'general.ideal'})})</th>
            {reportHeaders}
          </tr>
        </thead>
        <tbody>
          {tableRows}
        </tbody>
      </table>;
    });

    if (this.state.loaded) {
      return <CustomIntlWrapper locale={locale} messages={this.state.messages[locale]}>
        <Inner />
      </CustomIntlWrapper>;
    }
    return <div/>;

  };

  getTableFooter = (currentPageAnalyses) => {
    return currentPageAnalyses.map(analysis =>
      <a href={path.join(window.location.hash, `../analysis/report/${analysis.id}`)}>
        <button className='btn btn-primary'
                style={{float: 'none', marginLeft: 0}}>{formatMessage({id: 'general.view.report'})}</button>
      </a>
    );
  };

  getTableHeader = (currentPageAnalyses) => {
    return currentPageAnalyses.map(analysis =>
      moment(analysis.created).format(dateTimeFormats.numeralDate)
    );
  };

  canScrollLeft = () => this.state.firstTest > 0;
  canScrollRight = () => this.state.lastTest < this.state.analyses.length;

  changeDate = (data) => {
    if (!data.value ||
      !moment(data.value, dateTimeFormats.numeralDate, true).isValid() ||
      this.state[data.key] === data.value ||
      this.state[data.key].format('L') === data.value.format('L')) {
      return;
    }

    this.setState({
      [data.key]: data.value,
      loaded: false,
      analyses: [],
    });
  };

  checkPOSPermission = () => {
    const {user, dealer} = this.state;

    if (user && dealer && dealer.CurrentPOSIntegration === 0) {
      return false;
    }

    if (user.isDealerAdmin) {
      return true;
    }

    if (user.isAdmin && dealer.managerPurchaseHistory) {
      return true;
    }

    return !!(user.isTestStation && dealer.testerPurchaseHistory);
  };

  exportReport = intl => {
    let idealRanges = idealRangesFormatted(this.props.intl.formatMessage);

    let analyses = this.state.analyses.map(analysis => {
      for (let key in idealRanges) {
        analysis[key] = formatCell(intl, key, analysis, this.state.dealer);
        if (analysis[key] && analysis[key].length > 0) {
          analysis[key] = analysis[key][0];
        }
      }

      analysis.created = moment(analysis.created).format(dateTimeFormats.numeralDate);

      return analysis;
    });

    let keys = ['created'];

    for (let key in idealRanges) {
      keys.push(key);
    }

    let titles = ['Date'];

    for (let key in idealRanges) {
      if (typeof idealRanges[key].title === 'function') {
        titles.push(idealRanges[key].title(this.state.dealer, this.state.branch, this.state.pool, this.props.intl.formatMessage, !!analyses.filter(x => !!x.optimizerProductID).length));
      } else {
        titles.push(idealRanges[key].title);
      }
    }

    downloadCSV(
      analyses,
      keys,
      titles,
      'report-history.csv'
    );
  };

  fetchData = () => {
    let apis = [];
    let {formatMessage} = this.props.intl;

    apis.push(analysisApi.getAnalyses(this.props.poolID, this.state.start.format(), this.state.end.format()));
    apis.push(customerApi.getCustomer(parseInt(this.props.customerID)));
    apis.push(poolApi.getPool(parseInt(this.props.poolID)));
    apis.push(productApi.getProducts());
    apis.push(dealerApi.getDealer(parseInt(session.getUser().dealerId)));
    apis.push(CustomIntlWrapper.fetchFile('en-US'));
    apis.push(CustomIntlWrapper.fetchFile('fr-CA'));
    apis.push(getAllNotes(this.props.customerID));
    Promise.all(apis)
      .then(([analyses, customer, pool, products, dealer, enUS, frCA, notes]) => {
        let poolTypeText = 'Pool';

        if (pool.typeID === 2) {
          poolTypeText = 'Spa';
        }
        if (pool.typeID === 3) {
          poolTypeText = 'Swim Spa';
        }
        branchApi.getBranch(customer.branchID)
          .then(branch => {
            this.setState({
              analyses: analyses,
              branch: branch,
              customer: customer,
              dealer: dealer,
              loaded: true,
              pool: pool,
              poolTypeText: poolTypeText,
              products: products,
              notes,
              messages: {
                'en-US': enUS,
                'fr-CA': frCA,
              },
            });

            this.getPurchasesForAnalyses(analyses);
          });
      })
      .catch(e => {
        console.error(e);
        events.publish('error.user', {message: formatMessage({id: 'test.history.error.fetching'})});
      });
  };

  printReport = () => {
    let contactName = null;
    let {formatMessage} = this.props.intl;

    if (this.state.customer.customerContacts.length > 0) {
      let contact = this.state.customer.customerContacts[0];

      contactName = getContactName(contact, contactName);
    }

    events.publish('print',
      <IntlWrapper>
        <h1>{contactName.trim()}</h1>
        <h3>{this.state.poolTypeText + ' ' + formatMessage({id: 'general.system.history'})}</h3>
        <br/>
        {this.getReport()}
      </IntlWrapper>
    );
  };

  scrollLeft = () => {
    let {firstTest, lastTest} = this.state;

    if (firstTest > 0) {
      this.setState({
        firstTest: firstTest - 1,
        lastTest: lastTest - 1,
      });
    }
  };

  scrollRight = () => {
    let {firstTest, lastTest, analyses} = this.state;

    if (lastTest < analyses.length) {
      this.setState({
        firstTest: firstTest + 1,
        lastTest: lastTest + 1,
      });
    }
  };

  showReport = () => {
    if (!this.props.showPrint) {
      let hash = window.location.hash;
      let newHash = path.join(hash, '/print');

      window.location.hash = newHash;
    }
  };

  switchFormat = () => {
    if (this.props.showPrint) {
      let hash = window.location.hash.split('/print')[0];

      window.location.hash = hash;
    } else {
      this.showReport();
    }
  };

  togglePOSData = () => {
    this.setState({posdata: !this.state.posdata});
  };

  render() {
    let contact = null;
    let contactName = 'Customer';
    let {formatMessage} = this.props.intl;

    if (this.state.customer.customerContacts.length > 0) {
      contact = this.state.customer.customerContacts[0];

      for (let i = 0; i < this.state.customer.customerContacts.length; i++) {
        if (this.state.customer.customerContacts[i].id === this.props.contactId) {
          contact = this.state.customer.customerContacts[i];
        }
      }
      contactName = contact.nameFirst || contact.nameLast ? (contact.nameFirst || '') + ' ' + (contact.nameLast || '') : contact.organization;
    }

    //Generate customer id for url purpose
    let customerUrl = this.props.customerID.toString();

    if (!isNaN(this.props.contactId)) {
      customerUrl += '.' + this.props.contactId;
    }

    let subTitle = this.state.pool.softSoakTRIO ? 'Trio ' : '';

    subTitle += chemicalBaseTypeNames(this.state.pool.typeID, this.state.pool.chemicalBaseTypeID || 2, formatMessage);

    let alexProdID = this.state.customer && this.state.customer.accountNum ? <div className='heading-alexid'>
      <span className='heading-alexid-title'><FormattedMessage id='general.alexid'/>:</span> {this.state.customer.accountNum}
    </div> : null;

    return (
      <div className='container analysis-report-page'>
        <Loader loaded={this.state.loaded}>
          <Header mainTitle={contactName}
                  mainTitleReturn={'customer/' + customerUrl}
                  subTitle={subTitle}>
            {alexProdID}
          </Header>

          <AnalysisTabs systemPath={path.join(location.hash, '..')}/>
          <div className='row'>
            <div className='col-sm-3'>
              <div style={{marginLeft: 20}}>
                <LayoutDatePicker label={formatMessage({id: 'general.date.from'})}
                                  value={this.state.start}
                                  title={formatMessage({id: 'test.history.filter.results'})}
                                  editMode={true}
                                  dateFormat={dateTimeFormats.numeralDate}
                                  dataKey='start'
                                  onChange={this.changeDate}/>
              </div>
            </div>
            <div className='col-sm-3'>
              <LayoutDatePicker label={formatMessage({id: 'general.date.to'})}
                                value={this.state.end}
                                title={formatMessage({id: 'test.history.filter.results'})}
                                editMode={true}
                                dateFormat={dateTimeFormats.numeralDate}
                                dataKey='end'
                                onChange={this.changeDate}/>
            </div>
            <div className='col-sm-6'>
              <div className='pull-right'>
                <HoverButton icon='bl-back'
                             hoverIcon='bl-back-hover'
                             onClick={this.scrollLeft}
                             disabled={!this.canScrollLeft()}/>
                <HoverButton icon='bl-forward'
                             hoverIcon='bl-forward-hover'
                             onClick={this.scrollRight}
                             disabled={!this.canScrollRight()}/>
              </div>
            </div>
          </div>
          {
            this.state.analyses.length > 0 ?
              this.getReport() :
              <h4>{formatMessage({id: 'test.history.analyses.display'})}</h4>
          }
        </Loader>
        <PageFooter>
          <EmailModal
            title={this.state.poolTypeText + ' ' + formatMessage({id: 'general.history.report'})}
            subject={this.state.poolTypeText + ' ' + formatMessage({id: 'general.system.history'})}
            baseMessage={ReactDOMServer.renderToString(<div>{this.getReportForEmail('en-US')}</div>)}
            baseMessageFr={ReactDOMServer.renderToString(<div>{this.getReportForEmail('fr-CA')}</div>)}
            customerID={this.state.customer.id || 0}
            type={emailSendingTypes.reportHistory}
            contacts={this.state.customer.customerContacts}
            caslRestricted={this.state.dealer.country === countries.CA}/>
          <FooterButton label={formatMessage({id: 'general.print'})}
                        icon='bl bl-2x bl-print'
                        onClick={this.printReport}/>
          <FooterButton label={formatMessage({id: 'general.export'})}
                        icon='bl bl-2x bl-export'
                        onClick={() => this.exportReport(this.props.intl)}/>
        </PageFooter>
      </div>
    );
  }
}

const WrapperWaterAnalysisReport = injectIntl(WaterAnalysisReport);

export default WrapperWaterAnalysisReport;
